import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { BusinessCardFacade } from '../state/business-card.facade';

@Injectable()
export class BusinessCardResolver {
  resolve(route: ActivatedRouteSnapshot): boolean {
    const cardId = route.paramMap.get('uuid');
    cardId && this.facade.loadBusinessCard(cardId);
    return true;
  }

  constructor(private facade: BusinessCardFacade) {}
}
